(function () {
    'use strict';

    angular
        .module('ActionManager')
        .factory('action-emit-ga-event', actionFunc);

    function actionFunc($q, GaService, lodash, PanelManager) {
        return function(options, eventData, actionResponse) {
            return $q.when(run());
            function run() {
                const modelData = {
                    actionResponse: actionResponse,
                    eventData: eventData
                };
                const panel_id = lodash.get(options, 'panel_id', false);
                if (panel_id) {
                    const panel = PanelManager.get(panel_id);
                    var panelModel = panel.getModel();
                    modelData.panelModel = panelModel
                }

                GaService.addEvent(options, modelData);
            }
        };
    }
})();